var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovieIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5483 -1.3413 1.3413 1.5483 473.7255 528.4695)",
    id: 547539
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-138.7235, -138.7222)",
    d: "M 59.488 117.299 c -0.504 -4.237 -2.007 -8.171 -4.273 -11.556 l 202.992 -67.776 L 247.552 6.051 c -1.549 -4.638 -6.566 -7.141 -11.201 -5.594 L 15.54 74.182 c -4.635 1.547 -7.143 6.563 -5.594 11.201 l 5.225 15.647 c -5.216 4.843 -8.488 11.752 -8.488 19.415 c 0 9.924 5.486 18.586 13.582 23.127 v 125.02 c 0 4.891 3.967 8.853 8.854 8.853 h 232.793 c 4.885 0 8.852 -3.963 8.852 -8.853 V 117.299 H 59.488 z M 188.869 26.724 l 26.875 -8.973 l -6.467 26.14 l -26.875 8.973 L 188.869 26.724 z M 122.47 48.893 l 26.877 -8.973 l -6.467 26.139 l -26.875 8.974 L 122.47 48.893 z M 33.181 133.946 c -7.442 0 -13.498 -6.056 -13.498 -13.5 c 0 -7.444 6.056 -13.5 13.498 -13.5 c 7.444 0 13.5 6.056 13.5 13.5 C 46.681 127.89 40.625 133.946 33.181 133.946 z M 56.074 71.062 l 26.877 -8.973 l -6.467 26.14 l -26.877 8.974 L 56.074 71.062 z M 82.476 147.192 H 54.142 l 14.412 -22.746 h 28.334 L 82.476 147.192 z M 138.554 124.446 h 28.334 l -14.412 22.746 h -28.334 L 138.554 124.446 z M 131.599 234.372 v -60 l 47.783 30 L 131.599 234.372 z M 222.476 147.192 h -28.334 l 14.412 -22.746 h 28.334 L 222.476 147.192 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieIcon);
export default __webpack_public_path__ + "static/media/movie-icon.c1b7587c3cad2de912e75327112c4359.svg";
export { ForwardRef as ReactComponent };